export const ADD_SLIDE_ITEM = 'ADD_SLIDE_ITEM';
export const CHANGE_ACTIVE_AD_MODAL = 'CHANGE_ACTIVE_AD_MODAL';
export const CHANGE_ACTIVE_SLIDE = 'CHANGE_ACTIVE_SLIDE';
export const CHANGE_AD_FIELD = 'CHANGE_AD_FIELD';
export const CHANGE_CAMPAIGN_FIELD = 'CHANGE_CAMPAIGN_FIELD';
export const CHANGE_CAROUSEL_ITEM_VALUE = 'CHANGE_CAROUSEL_ITEM_VALUE';
export const CHANGE_FIELD_VALUE = 'CHANGE_FIELD_VALUE';
export const CHANGE_LIFETIME_BUDGET = 'CHANGE_LIFETIME_BUDGET';
export const CHECK_CAMPAIGN = 'CHECK_CAMPAIGN';
export const VALIDADE_SLIDES = 'VALIDADE_SLIDES';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const REMOVE_SLIDE = 'REMOVE_SLIDE';
export const RESET_CAMPAIGN_FIELDS = 'RESET_CAMPAIGN_FIELDS';
export const RESET_CAROUSEL_FIELDS = 'RESET_CAROUSEL_FIELDS';
export const RESET_STATE = 'RESET_STATE';
export const SHOW_ERROR = 'SHOW_ERROR';
export const TOGGLE_CALENDAR = 'TOGGLE_CALENDAR';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const TOGGLE_SINGLE_BUDGET_SWITCH_BUTTON = 'TOGGLE_SINGLE_BUDGET_SWITCH_BUTTON';
